export enum GenerationStatus {
  READY = 'ready',
  NEEDS_CLARIFICATION = 'needs_clarification',
}
